import { render, staticRenderFns } from "./ConsentFailure.vue?vue&type=template&id=15238e71&scoped=true"
import script from "./ConsentFailure.vue?vue&type=script&lang=js"
export * from "./ConsentFailure.vue?vue&type=script&lang=js"
import style0 from "./ConsentFailure.vue?vue&type=style&index=0&id=15238e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15238e71",
  null
  
)

export default component.exports